import * as Cookie from 'js-cookie';
// tslint:disable
import { get } from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { InputField } from '../../components/fields/input.field';
import { ConsoleLib } from '../../components/libs/console.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ListConsole } from '../../components/structurals/list-console';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { Pagination } from '../../components/structurals/pagination';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import { ResourceModal } from '../../components/structurals/resource-modal';
import {IriPresenter} from "../../components/structurals/presenters/iri-presenter";
import {IriField} from "../../components/fields/iri.field";
import axios from "axios";
import {Environment} from "../../environment/environment";
import {Subject} from "rxjs";

export class DefaultUserList extends React.Component<any, any> {

    public loading$: Subject<any> = new Subject();

    componentDidMount() {
        this.setState({
            user: JSON.parse(Cookie.get('user') as string),
            site: JSON.parse(Cookie.get('site') as string),
        });
    }

    public state: any = {isLoading: false};

    public handleRawClick(id: any) {
        window.location.href = `/user/${id}`;
    }

    render() {
        return (
            <ListResourceLoader entity="user" forceQuery={{limit: 50, 'order[id]': 'desc'}} render={(list: ListLib) => <div>
                <LoaderComponent isLoading$={this.loading$}/>
                <div id="page-title">
                    <h2>
                        Users
                        <div className="pull-right">
                            <a href="/user/create" className='btn btn-sm btn-primary'>Create new user</a>
                        </div>
                    </h2>
                    <p>Lorem</p>
                </div>
                <ListConsole
                    className="col-xs-12 col-lg-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>
                        <InputField
                            field={console.setQuery('_keyword', {title: 'Search', placeholder: 'some keyword'})}/>

                        <InputField
                            field={console.setQuery('email', {title: 'E-mail address', placeholder: '@travelweekly.co.uk'})}/>

                        <InputField
                            field={console.setQuery('importedTag', {title: 'Tag', placeholder: 'some keyword'})}/>

                        <CheckboxField
                            field={console.setQuery('enabled', {title: 'Only invalidate users'}, (value: any) => !value)}
                        />
                        <CheckboxField
                            field={console.setQuery('enabled', {title: 'Only validate users'})}
                        />


                        <IriField
                            field={console.setQuery('site', {title: 'Source (site)', iri: 'site'})}
                            defaultAll={true}
                            itemRender={(item: any) => item.name}
                        />
                        <hr/>

                        <button className={'btn btn-primary'} onClick={(event: any)=> this.activate()}>Activate selected user(s)</button>

                    </div>}
                />

                <div className="col-xs-12 col-lg-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <th>#</th>
                                    <th><input type="checkbox" name={`selectAll`} onChange={(event: any) => this.checkAll(event) }/></th>
                                    <th>Name</th>
                                    <th>E-mail</th>
                                    <th>Validate</th>
                                    <th>Access to {this.state.site.name}</th>
                                    <th>Registered</th>
                                    <th>Registered from</th>
                                    <th>Phone</th>
                                    <th/>
                                </tr>
                            );
                        }}
                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>
                                        <input type="checkbox" name={`selected[]`} value={item.id}/>
                                    </td>
                                    <td>
                                        {get(item, 'firstName', '-')} {get(item, 'surName', '-')}

                                        {get(item,'importedTag') ? <span><br/><span className="bs-label badge-primary">#{get(item, 'importedTag', '-')}</span></span> : '' }
                                    </td>

                                    <td>{get(item, 'email', '-')}</td>
                                    <td>
                                        {get(item, 'enabled') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {get(item, 'accessToSite') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {moment(get(item, 'createdAt')).format('DD/MM/Y H:mm')}
                                    </td>
                                    <td>
                                        <IriPresenter iri={get(item, 'site.@id')} render={(site: any) => get(site, 'name', '-')}/>
                                    </td>
                                    <td>
                                        <IriPresenter iri={get(item, 'person.@id')} path="phone"/>
                                    </td>
                                    <td>
                                        <button className="btn btn-xs btn-primary mb-2" onClick={() => actions.open(item['@id'])}>View details</button>
                                        <ResourceModal
                                            title={'Set new password'}
                                            entity={'modal-set-new-password'}
                                            extClass="btn-xs btn-warning"
                                            entityId={item.id}
                                        />
                                    </td>
                                </tr>
                            );
                        }}/>

                    <Pagination config={list.pagination}/>
                </div>
            </div>}
            />
        );
    }

    private checkAll(event: any)
    {
        $('tr input[type=checkbox]').prop('checked', event.target.checked)
    }

    private async activate()
    {
        this.loading$.next(true);
        await $('tr input[type=checkbox]:checked').map(async  (i: any, element: any) => {
            await axios.put(`${Environment.get('api.base')}/user/${element.value}`, {
                enabled: true
            }, {
                withCredentials: true,
            }).then(() => {
                $(element).closest('tr').addClass('bg-success')
                $(element).closest('tr').find('td').css('background','none')
            })
            this.loading$.next(false);
        })


    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/default.user.tsx